/* eslint-disable react/display-name */
import { useState } from 'react';

import { Button } from '@dec/shared';
import { ButtonAction } from '@dec/shared';
import { Check, HookFormResolver } from '@dec/shared';
import { type HookFormMethods } from '@dec/shared';
import { BtnToolbar } from '@dec/shared';
import { ButtonGroup, Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { useOperationsList } from '../../../Operations/EconomyActivity/hooks/useOperationsList';
import { type EconomyActivity } from '../../../Operations/EconomyActivity/models/economyActivity.model';
import { useTaxpayerRequestStore } from '../../stores/useTaxpayerRequestStore';
import ProgressBar from '../components/progress-bar';
import { ValidationsResolver } from '../rules';
import { rulesContactData } from '../rules/contact';

import { type OperationsModel, type ProgressStepProps } from './types';
interface Props {
  onSubmit: (data: any) => void;
  operations: Array<EconomyActivity>;
  readonly?: boolean;
}

export const Operation = ({ onSubmit, operations, readonly }: Props) => {
  const { t, i18n } = useTranslation();
  const [{ data, loading, error }] = useOperationsList(true);
  const taxpayer = operations;
  const filterSelect = (result: OperationsModel) => {
    const list = (data ?? []).filter((c, index) =>
      Boolean((result.selectedOperations as Array<any>)[index])
    );

    onSubmit(list);
  };
  const active = (obj?: any): boolean => {
    if (taxpayer) {
      const result = taxpayer.filter(
        (economyActivity: EconomyActivity) => economyActivity.id == obj.id
      );
      return result.length > 0;
    }
    return false;
  };
  return (
    <>
      <ValidationsResolver rules={rulesContactData}>
        {({ validations }: any) => {
          return (
            <HookFormResolver nameForm={'formOperations'} onSubmit={filterSelect}>
              {({ formState: { errors }, reset, setValue }: HookFormMethods) => {
                return (
                  <>
                    <hr />
                    <Row>
                      <Col>
                        <h2>{t('taxpayer-request.messages.selectOperations')}</h2>
                      </Col>
                    </Row>

                    {data && data.length > 0 && (
                      <Row>
                        <Col>
                          {data
                            .filter((x) => active(x))
                            .map((obj: any, index) => {
                              return (
                                <>
                                  <div className="card mb-3">
                                    <div className="card-body">
                                      <h5 className="card-title">{obj.name}</h5>

                                      <Check
                                        key={obj.id}
                                        label={obj.description}
                                        name={`selectedOperations[${index}]`}
                                        defaultValue={active(obj)}
                                        disabled={readonly}
                                      />
                                    </div>
                                  </div>
                                </>
                              );
                            })}
                        </Col>
                      </Row>
                    )}
                  </>
                );
              }}
            </HookFormResolver>
          );
        }}
      </ValidationsResolver>
    </>
  );
};

export default (props: ProgressStepProps) => {
  const [dirty, setDirty] = useState(false);
  const taxpayer = useTaxpayerRequestStore((s) => s.form.operations);
  const addOperationsData = useTaxpayerRequestStore((s) => s.addOperationsData);
  const { t } = useTranslation();
  const onSubmit = (data: Array<EconomyActivity>) => {
    data?.length == 0 ? setDirty(true) : props.nextStep();

    addOperationsData(data);
  };

  return (
    <>
      <Operation operations={taxpayer ? taxpayer : []} onSubmit={onSubmit} />
      {dirty && taxpayer?.length == 0 && (
        <div className="invalid-feedback d-block">{t('taxpayer-request.messages.operations')}</div>
      )}
      <ProgressBar percentage={props.percentage} />
      <BtnToolbar>
        <ButtonGroup>
          <Button
            form="formTextData"
            action={ButtonAction.previous}
            onClick={() => props.previousStep()}
          />
        </ButtonGroup>
        <ButtonGroup>
          <Button
            form="formOperations"
            variant="primary"
            action={ButtonAction.next}
            type={'submit'}
          />
        </ButtonGroup>
      </BtnToolbar>
    </>
  );
};
